var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('ErrorSection',{attrs:{"image":"404.svg","title":_vm.$t('notFound.title'),"subtitle":_vm.$t('notFound.subtitle'),"content":_vm.$t('notFound.content')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }